import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';

@Component({
    selector: 'from-to-form',
    templateUrl: './from-to-form.component.html',
    styleUrls: ['./from-to-form.component.scss'],
    standalone: false
})
export class FromToFormComponent implements OnInit {

  constructor() { }

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow:CardView = {};
  condition:string = '0=0'
  
  ngOnInit(): void {
  }

  onTabChanged(event:MatTabChangeEvent){
    this.eventsSubject.next(event.tab.content.templateRef.elementRef.nativeElement.id);
  
  }
}
